import type { HealthStatus } from '@/types/integrations'

export const HEALTH_DOTS: Record<HealthStatus, string> = {
  healthy: 'bg-green-500',
  stale: 'bg-yellow-500',
  degraded: 'bg-yellow-500',
  circuit_broken: 'bg-red-500',
  never_synced: 'bg-gray-400',
  disabled: 'bg-gray-400',
}

export const HEALTH_LABELS: Record<HealthStatus, string> = {
  healthy: 'Healthy',
  stale: 'Stale',
  degraded: 'Degraded',
  circuit_broken: 'Circuit Broken',
  never_synced: 'Never Synced',
  disabled: 'Disabled',
}

export function HealthDot({ status, size = 'sm' }: { status: HealthStatus; size?: 'sm' | 'md' }) {
  const sizeClass = size === 'md' ? 'h-3 w-3' : 'h-2.5 w-2.5'
  return <div className={`${sizeClass} rounded-full ${HEALTH_DOTS[status]}`} />
}
